import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles.css';

// Without this, any error thrown while rendering unmounts the tree and leaves
// a blank white page - the reason visible only to someone who thinks to open
// the console. Showing it on screen makes a deployed failure diagnosable by
// whoever hits it.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled error:', error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="center-screen">
        <div className="card" style={{ maxWidth: 640 }}>
          <h2>Something went wrong</h2>
          <p className="muted">This is a bug, not something you did. The details below help pin it down.</p>
          <pre className="input" style={{ whiteSpace: 'pre-wrap', fontSize: 13 }}>
            {String(this.state.error?.stack || this.state.error)}
          </pre>
          <button type="button" className="btn secondary" onClick={() => window.location.reload()}>Reload</button>
        </div>
      </div>
    );
  }
}

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);
